<template>
<div class="TableBox">
    <search-template page_name="成本与返点表" :timeMonth='timeMonth' source="cost" @search_event='search_event'></search-template>
    <div class="operationUploadBox clear">
        <div class="operationUpload">
            <div style="margin-top:5px">
                <div class="batchDelete" style="background:#d51414;border-color:#d51414" @click="batchDelete">批量删除</div>
                <div class="batchDelete" style="background:#FF9B3B;border-color:#FF9B3B;margin-top:5px;" @click="clearSelection">清空选中</div>
            </div>
            <div style="margin-top:5px">
                <div class="batchDelete" @click="batchSetRedInvoice('red_invoice_date')">批量修改红字发票日期</div>
                <div class="batchDelete" style="margin-top:5px" @click="batchSetRedInvoice('refund_invoice_date')">批量修改返点开票日期</div>
            </div>
            <div>
                <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E6%88%90%E6%9C%AC%E6%A8%A1%E6%9D%BF.xlsx'>成本订单导入模板</a>
                <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E8%BF%94%E8%B4%A7%E6%A8%A1%E6%9D%BF.xlsx'>返货订单导入模板</a>
            </div>
            <div>
                <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E7%BA%BF%E4%B8%8B%E8%A1%A5%E6%AC%BE%E6%A8%A1%E6%9D%BF.xlsx'>线下补款导入模板</a>
                <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E6%89%A7%E8%A1%8C%E5%AA%92%E4%BB%8B%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'>执行媒介导入模板</a>
                <!-- <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E6%88%90%E6%9C%AC%E5%8F%91%E7%A5%A8%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'>成本发票导入模板</a> -->
            </div>
            <el-upload
                style="display: inline-block;float: left;"
                ref="upload"
                :action="URL.BASEURL + URL.orderImportCost"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :on-progress='uploadProgress'
                :data="{
                    admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                    ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                    sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                    type: 7
                }"
                :show-file-list='false'
                :auto-upload="true"
                accept=".xlsx,.csv"
                >
                <div class="batchDelete">成本批量导入</div>
            </el-upload>
            <el-upload
                style="display: inline-block;float: left;"
                ref="upload"
                :action="URL.BASEURL + URL.orderImportCost"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :on-progress='uploadProgress'
                :data="{
                    admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                    ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                    sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                    type: 2
                }"
                :show-file-list='false'
                :auto-upload="true"
                accept=".xlsx,.csv"
                >
                <div class="batchDelete">返货批量导入</div>
            </el-upload>
            <el-upload
                style="display: inline-block;float: left;"
                ref="upload"
                :action="URL.BASEURL + URL.orderImportCost"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :on-progress='uploadProgress'
                :data="{
                    admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                    ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                    sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                    type: 3
                }"
                :show-file-list='false'
                :auto-upload="true"
                accept=".xlsx,.csv"
                >
                <div class="batchDelete">线下补款批量导入</div>
            </el-upload>
            <el-upload
                style="display: inline-block;float: left;"
                ref="mjExecUpload"
                :action="URL.BASEURL + URL.mjExecImportValidate"
                :on-success="mjExecUploadSuccess"
                :on-error="mjExecUploadError"
                :on-progress='mjExecUploadProgress'
                :data="{
                    admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                    ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                    sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                }"
                :show-file-list='false'
                :auto-upload="true"
                accept=".xlsx,.csv"
                >
                <div class="batchDelete">执行媒介导入</div>
            </el-upload>
            <!-- <el-upload
                style="display: inline-block;float: left;"
                ref="upload"
                :action="URL.BASEURL + URL.orderImportCost"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :on-progress='uploadProgress'
                :data="{
                    admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                    ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                    sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                    type: 4
                }"
                :show-file-list='false'
                :auto-upload="true"
                accept=".xlsx,.csv"
                >
                <div class="batchDelete">成本发票批量导入</div>
            </el-upload> -->
        </div>
        <div class="refreshIcon batchDelete" @click="init({page:1})">
            刷新
            <i class="el-icon-refresh"></i>
        </div>
        <div class="batchDelete" @click="init({page:1,exportFlag:true})">导出</div>
    </div>
     <ux-grid
        ref="plxTable"
        :data="datas"
        :height="height"
        :checkboxConfig="{checkMethod: selectable, highlight: true}"
        @selection-change="selectionChange"
        @table-body-scroll="scroll"
        show-footer-overflow="tooltip"
        show-overflow="tooltip"
        keep-source
        :edit-config="{trigger: 'manual', mode: 'row'}"
        size="mini">
         <ux-table-column type="checkbox" align="center" fixed="left" width="40"/>
         <ux-table-column
                 v-for="item in columns"
                 :key="item.id"
                 :resizable="item.resizable"
                 :field="item.prop"
                 :title="item.label"
                 :width="item.width"
                 :fixed="item.fixed"
                 show-header-overflow='tooltip'
                 :edit-render="item.editRender?true:false"
                 align="center"/>
        <ux-table-column title="状态" align="center" minWidth="60" fixed="right" field="describe">
            <template v-slot="{ row }">
                <span v-if="row.status<3">未锁单</span>
                <div v-else>
                    <span v-if="row.status == 3 && (row.cost_verify_status == 0||!row.cost_verify_status)">媒介锁单</span>
                    <span v-if="row.status == 4 && (row.cost_verify_status == 0||!row.cost_verify_status)">财务锁单</span>
                    <span v-if="row.cost_verify_status == 1">待媒介审核</span>
                    <span v-if="row.cost_verify_status == 2">媒介通过</span>
                    <span v-if="row.cost_verify_status == 3">媒介驳回</span>
                    <span v-if="row.cost_verify_status == 4">财务通过</span>
                    <span v-if="row.cost_verify_status == 5">财务驳回</span>
                </div>
            </template>
        </ux-table-column>
        <ux-table-column title="操作" align="center" minWidth="80" fixed="right" field="describe">
            <template v-slot="{ row }">
                <span style="color:#ff9b3c;cursor: pointer;margin-right:5px;" v-if="row.status>=3&&(row.cost_verify_status==1||row.cost_verify_status==2)" @click="delVerifyOrder(row)">撤销</span>
                <span v-else>
                    <span style="color:#5B7BFE;cursor: pointer;margin-right:5px;" @click="editRowEvent(row)">编辑</span>
                </span>
                <span style="color:#5B7BFE;cursor: pointer;" @click="order_id=row.order_id;record_id=row.id;journalFlag=true;">记录</span>
            </template>
        </ux-table-column>
     </ux-grid>
     <div ref="pagination" class="paginationBox" style="height: 30px;">
        <el-pagination
            small
            background
            :current-page="page"
            :page-size="page_size"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, jumper"
            :total="total" />
    </div>
     <el-dialog title="编辑" :visible.sync="editFlag" width="70%" top="10vh" :close-on-click-modal='false'>
        <costrebate-edit v-if="editFlag" :editDataTotal='editData' @cancelToast='cancelToast' @emit_refresh="emit_refresh"></costrebate-edit>
    </el-dialog>
    <el-dialog :title="is_red == 'red_invoice_date' ? '修改红字发票日期' : '修改返点开票日期'" :visible.sync="date_flag" width="400px" top="10vh" :close-on-click-modal='false'>
        <el-date-picker
        v-model="invoice_date"
        size="mini"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期">
        </el-date-picker>
        <el-button type="primary" size="mini" @click="batchSetRedInvoiceEvent">确定</el-button>
    </el-dialog>
    <!-- 查看日志 -->
    <el-dialog title="订单记录" :visible.sync="journalFlag" width="60%" top="10vh" :close-on-click-modal='false'>
        <journal v-if="journalFlag" @cancelToast='cancelToast' :order_id='order_id' :record_id='record_id'></journal>
    </el-dialog>
</div>
</template>
<script>
import journal from '../orderJournal'
import columnsJson from '../json/cost.js'
import searchTemplate from '../searchTemplate.vue'
    import costrebateEdit from './costRebateEdit'
    export default {
        components:{
            costrebateEdit,
            journal,
            searchTemplate
        },
      data() {
        return {
          height: 0,
          columns: [],//表头
          scrollTop: 0,
          loading:false,
            timeMonth:'',
          editData:{},
          editFlag:false,
          multipleSelection:[],
          multipleSelection1:{},
          invoice_date:'',
          date_flag:false,
          is_red:'',
          order_id:'',
          record_id:'',
          journalFlag:false,
          page:1,
          page_size:100,
          total:0,
          condition_data:{},
          search_data:[],
          selectionList:[],
          flag:false,
          mjExecImportData: null, // 存储执行媒介导入的响应数据
          execMediumList: [], // 执行媒介列表
          datas: [] // 表格数据
        }
      },
      created(){
        var date = new Date();
        if (date.getMonth() === 0) { // 默认值为上个月份；月份为 0 时处理跨年问题
          this.timeMonth = (date.getFullYear() - 1) + '-' + '12'
        } else {
          this.timeMonth = date.getFullYear() + '-' + ((date.getMonth()) < 10 ? '0' + (date.getMonth()) : (date.getMonth()));
        }
        this.columns = columnsJson
      },
      mounted () {
        this.$nextTick(() => {
          this.computeGridHeight()
          window.addEventListener('resize', this.computeGridHeight, { passive: true })
        })
        this.getExecMediumList(); // 获取执行媒介列表
        this.init({page:1})
      },
      beforeDestroy () {
        try {
          window.removeEventListener('resize', this.computeGridHeight)
        } catch (e) {}
      },
      methods: {
          computeGridHeight () {
            this.$nextTick(() => {
              try {
                const viewportH = window.innerHeight || document.documentElement.clientHeight
                const gridEl = this.$refs.plxTable && this.$refs.plxTable.$el
                const pagEl = this.$refs.pagination
                if (!gridEl) return
                const gridTop = gridEl.getBoundingClientRect().top
                const pagH = pagEl ? pagEl.offsetHeight : 56
                const gap = 16
                const footer = 29
                let h = Math.floor(viewportH - gridTop - pagH - gap - footer)
                if (h < 300) h = 300
                this.height = h
              } catch (e) {
                const h = document.documentElement.clientHeight - 320
                this.height = h > 400 ? h : 400
              }
            })
          },
          search_event(data){
              this.search_data = data;
                this.init({page:1})
          },
          // 获取执行媒介列表
          getExecMediumList() {
              this.$axios.get(this.URL.BASEURL + this.URL.getExecMediumList).then((res) => {
                  if (res && res.errno == "0") {
                      this.execMediumList = res.rst; // 存储执行媒介列表数据
                      // 更新执行媒介列的筛选选项
                      this.columns.forEach((column) => {
                        if (column.prop === 'exec_medium') {
                          column.filters = res.rst.map(item => ({
                            text: item.real_name,
                            value: item.id
                        }));
                      }
                  })
              }
              }).catch(() => {
              });
          },
          batchSetRedInvoice(name){//批量修改
            if(!this.multipleSelection || this.multipleSelection.length == 0){
                this.$message({
                    message: '未选择要修改的订单',
                    type: 'warning'
                })
                return
            }
            this.is_red = name
            this.date_flag = true;
          },
          batchSetRedInvoiceEvent(){
              if(this.invoice_date == '' || !this.invoice_date){
                  this.$message({
                    message: '请选择您要修改的日期',
                    type: 'warning'
                })
                  return;
              }
              this.$confirm('确定要修改吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    var arr = [];
                    this.multipleSelection.forEach((item)=>{
                        arr.push(item.id)
                    })
                    this.$loading(this.$loadingConfig)
                    var params = {
                        id_list: arr
                    }
                    params[this.is_red] = this.invoice_date
                    this.$axios.post(this.URL.BASEURL + this.URL.batchSetRedInvoice,params).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.$message({
                                message: '修改成功！',
                                type: 'success'
                            })
                            this.init({page:this.page})
                            this.date_flag =false;
                        }else {
                            this.$loading(this.$loadingConfig).close()
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                        this.$loading(this.$loadingConfig).close()
                    })
                }).catch(() => {
            });
          },
          batchDelete(){//批量删除
            if(!this.multipleSelection || this.multipleSelection.length == 0){
                this.$message({
                    message: '未选择要删除的订单',
                    type: 'warning'
                })
                return
            }
            this.$confirm('确定要删除所选中订单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    var arr = [];
                    this.multipleSelection.forEach((item)=>{
                        arr.push(item.id)
                    })
                    this.$loading(this.$loadingConfig)
                    this.$axios.post(this.URL.BASEURL + this.URL.costDel,{
                        ids: arr
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.$message({
                                message: '删除成功！',
                                type: 'success'
                            })
                            this.init({page:1})
                        }else {
                            this.$loading(this.$loadingConfig).close()
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                        this.$loading(this.$loadingConfig).close()
                    })
                }).catch(() => {
            });
          },
          emit_refresh(){//编辑成功
            this.editFlag = false;
            this.init({page:this.page})
          },
          cancelToast(){
            this.editFlag = false;
            this.journalFlag = false;
            },
          editRowEvent(row){//编辑
            this.editFlag = true;
            this.editData = row;
            this.editData.if_public = this.editData.if_public == '是' ? true : null
          },
          uploadSuccess(res, file, fileList){
            this.$loading(this.$loadingConfig).close()
            if(res.errno == 0){
                this.$alert('导入成功！', '提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: action => {
                        this.init({page:1})
                    }
                });
            }else {
                var errHint = ''
                if(Array.isArray(res.rst.error)){
                    errHint = '<p>有误字段：</p><ul>'
                    res.rst.error.forEach((item)=>{
                        errHint += `<li>第${item.row}行：${item.error.join(',')}</li>`
                    })
                    errHint += '</ul>'
                }else{
                    errHint = res.rst.error
                }
                this.$alert(errHint, res.err, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                });
            }
        },
        uploadError(err, file, fileList){
            this.$loading(this.$loadingConfig).close()
            this.$alert('上传失败', '服务器错误', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: action => {
                }
            });
        },
        uploadProgress(){//上传中
            this.$loading(this.$loadingConfig);
        },
        clearSelection(){//清空选中
            this.$refs.plxTable.clearSelection();
            this.multipleSelection = [];
            this.multipleSelection1 = {};
            this.selectionList = []
        },
        toggleSelection(rows) {
          if (rows) {
            rows.forEach((row,index) => {
                this.$refs.plxTable.toggleRowSelection([
                    {
                        row: row,
                        selected: true
                    }
                ])
                if(index == rows.length-1){
                    this.flag = true
                }
            });
          }
        },
        handleCurrentChange(val){
            this.init({page:val,selection:'clear'})
        },
        init({page,exportFlag,selection}){
            if(!selection || selection != 'clear'){
                this.clearSelection()
            }
            var params = {
                page:page,
                pagesize: this.page_size,
                month:this.timeMonth,
            }
            if(exportFlag){
                params.page = 1;
                params.pagesize = 10000
            }else{
                page = page?page:1;
                params.page = page;
                this.page = page;
            }
            if(this.search_data.length==0){
                params.month = this.timeMonth
            }else{
                this.search_data.forEach((item)=>{
                    if(item.property == 'if_public' || item.property == 'is_refund'){
                        params[item.property] = item.values == '是' ? 1 : null
                    }else if(item.property == 'exec_medium'){
                        // 执行媒介直接使用ID
                        params.exec_medium_id = item.values
                    }else{
                        params[item.property] = item.values
                    }
                })
            }
            this.$loading(this.$loadingConfig);
            this.$axios.get(this.URL.BASEURL + this.URL.costIndex,{
                params
            }).then((res) => {
                var res=res.data;
                this.$loading(this.$loadingConfig).close()
                if(res&& res.errno == 0){
                    var data = res.rst;
                    if(exportFlag){
                        this.$exportOrder({source:'cost',dataList:data.data,name:'成本与返点表'})
                    }else{
                        this.total = data.pageInfo.total;
                        this.datas = data.data // 现在datas是响应式的，表格会自动更新
                        this.$nextTick(()=>{
                            this.computeGridHeight()
                            if(this.multipleSelection1['page_'+this.page] && this.multipleSelection1['page_'+this.page].length != 0){
                                var rows = [],arr = []
                                this.multipleSelection1['page_'+this.page].forEach((item)=>{
                                    arr.push(item.id)
                                })
                                rows = this.datas.filter((v)=>{
                                    return arr.indexOf(v.id) != -1
                                })
                                this.flag =false
                                this.toggleSelection(rows)
                            }else{
                                this.flag = true
                            }
                        })

                    }
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.$loading(this.$loadingConfig).close()
            })
        },
       scroll ({scrollTop, scrollLeft}) {
         this.scrollTop = scrollTop
       },
        selectable ({row}) {//选择表格限制条件
            return true
            // return row.cost_verify_status != 1 && row.cost_verify_status !=2
        },
        selectionChange (row) {// 选中的行
          this.selectionList = row
          if(this.flag){
            this.multipleSelection1['page_'+this.page] = this.selectionList;
            this.multipleSelection = [];
            for(var i in this.multipleSelection1){
                this.multipleSelection = this.multipleSelection.concat(this.multipleSelection1[i])
            }
          }

        },
        delVerifyOrder(data){
            this.$confirm('确定要撤销此订单的修改?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                   this.$loading(this.$loadingConfig);
                    this.$axios.post(this.URL.BASEURL + this.URL.delVerifyOrder,{
                        order_id: data.order_id,
                        type:2
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.init({page:1})
                        }else {
                            this.$loading(this.$loadingConfig).close();
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                        this.$loading(this.$loadingConfig).close();
                    })
            }).catch(() => {
            });
        },
        // 执行媒介导入相关方法
        mjExecUploadSuccess(res, file, fileList) {
            this.$loading(this.$loadingConfig).close()
            if (res.errno == "0" || res.errno == 0) {
                // 成功响应（无冲突）
                this.$alert('导入成功！', '提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: action => {
                        // 添加小延迟确保服务器数据更新完成后再刷新列表
                        setTimeout(() => {
                            this.init({page:1});
                        }, 500);
                    }
                });
            } else if (res.errno == "1105" || res.errno == 1105) {
                // 成功响应（有冲突需要确认）
                this.mjExecImportData = res.rst.data;
                this.showMjExecConflictDialog(res.rst.data);
            } else if (res.errno == "1101" || res.errno == 1101) {
                // 错误响应（数据验证失败）
                this.showMjExecErrorDialog(res.rst.data);
            } else {
                this.$message({
                    message: res.err || res.info || '导入失败',
                    type: 'warning'
                })
            }
        },
        mjExecUploadError(err, file, fileList) {
            this.$loading(this.$loadingConfig).close()
            this.$alert('上传失败', '服务器错误', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: action => {
                }
            });
        },
        mjExecUploadProgress() {
            this.$loading(this.$loadingConfig);
        },
        // 显示执行媒介冲突确认弹窗
        showMjExecConflictDialog(data) {
            let conflictInfo = '';
            if (data.notices && data.notices.length > 0) {
                data.notices.forEach((item) => {
                    conflictInfo += `<li style="margin-bottom: 8px;">第${item.row}行：${item.notices.join(', ')}</li>`;
                });
            }
            
            this.$alert(conflictInfo, '媒介冲突确认', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确认导入',
                cancelButtonText: '取消',
                showCancelButton: true,
                customClass: 'media-conflict-dialog'
            }).then(() => {
                this.mjExecImportConfirm(1);
            }).catch(() => {
                this.mjExecImportConfirm(0);
            });
        },
        // 显示执行媒介错误信息弹窗
        showMjExecErrorDialog(data) {
            let errorInfo = '';
            if (data.errors && data.errors.length > 0) {
                errorInfo = '<p>数据验证失败：</p><ul>';
                data.errors.forEach((item) => {
                    errorInfo += `<li>第${item.row}行：${item.errors.join(', ')}</li>`;
                });
                errorInfo += '</ul>';
                
                // 如果有提示信息，也一并显示
                if (data.notices && data.notices.length > 0) {
                    errorInfo += '<p style="margin-top: 15px; color: #E6A23C;">提示信息：</p><ul>';
                    data.notices.forEach((item) => {
                        errorInfo += `<li>第${item.row}行：${item.notices.join(', ')}</li>`;
                    });
                    errorInfo += '</ul>';
                }
            } else {
                errorInfo = '导入失败';
            }
            
            this.$alert(errorInfo, '数据验证失败', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                customClass: 'media-conflict-dialog'
            });
        },
        // 执行媒介导入确认
        mjExecImportConfirm(confirm) {
            // 如果用户选择取消，直接关闭loading，不发送请求
            if (confirm == 0) {
                this.$loading(this.$loadingConfig).close();
                return;
            }
            
            this.$loading(this.$loadingConfig);
            this.$axios.post(this.URL.BASEURL + this.URL.mjExecImportConfirm, {
                confirm: confirm,
                admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
            }).then((res) => {
                var res = res.data;
                this.$loading(this.$loadingConfig).close();
                if (res && (res.errno == "0" || res.errno == 0 || res.code == 0)) {
                    if (confirm == 1) {
                        this.$message({
                            message: '导入成功！',
                            type: 'success'
                        });
                        // 添加小延迟确保服务器数据更新完成后再刷新列表
                        setTimeout(() => {
                            this.init({page:1});
                        }, 500);
                    }
                } else {
                    this.$message({
                        message: res.err || res.info || '导入失败',
                        type: 'warning'
                    });
                }
            }).catch(() => {
                this.$loading(this.$loadingConfig).close();
            });
        },
      },
    }
  </script>
  <style lang="scss" scoped>
  @import '@/assets/css/tableStyle.scss';
  .TableBox{
      padding:15px;
      background: #fff;
      margin-top: 15px;
  }
  .operationUpload,.operationUploadBox{
      display: flex;
      align-items: center;
  }
  .operationUpload{
      flex: 1;
  }
  .fileTemplate{
    font-size: 12px;
    margin-right: 10px;
    text-decoration: underline;
    margin: 8px 10px 0 0;
    color:#5B7BFE;
    display: block;
}
.batchDelete{
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #5B7BFE;
    background: #5B7BFE;
    color: #fff;
    margin-right: 16px;
    cursor: pointer;
    padding: 0 4px;
}
.uxGridBox{
    margin-top: 15px;
}
.refreshIcon{
    margin-right: 10px;
    background: #67c23a;
    border-color:#67c23a ;
  }

/* 媒介冲突弹窗自定义样式 */
.media-conflict-dialog .el-message-box{
    width: 550px !important;
}

.media-conflict-dialog .el-message-box__content {
    padding: 20px 20px 10px 20px;
}

.media-conflict-dialog .el-message-box__message {
    margin: 0;
}

.media-conflict-dialog .el-message-box__btns {
    padding: 10px 20px 20px 20px;
    text-align: right;
}

.media-conflict-dialog .el-message-box__btns .el-button {
    margin-left: 10px;
    padding: 8px 20px;
    font-size: 14px;
}

.media-conflict-dialog .el-message-box__btns .el-button--primary {
    background-color: #409EFF;
    border-color: #409EFF;
}

.media-conflict-dialog .el-message-box__btns .el-button--primary:hover {
    background-color: #66b1ff;
    border-color: #66b1ff;
}
  </style>


// WEBPACK FOOTER //
// src/components/Order/medium/costRebate.vue